export default {"src":"/pro/_next/static/media/base.1bc7ecca.svg","height":111,"width":111,"blurWidth":0,"blurHeight":0};